import React, { useEffect } from 'react';
import MaskLoading from '@/components/mask-loading';

const ColsContainer: React.FC<{
    children?: React.ReactNode;
    cols: number;
    onResize?: (width: number, height: number) => void;
}> = ({ cols, onResize, children }) => {
    const divRef = React.useRef<HTMLDivElement>(null);
    const [size, setSize] = React.useState({ width: 0, height: 0 });

    useEffect(() => {
        const resizeObserver = new ResizeObserver((entries) => {
            for (const entry of entries) {
                const { width, height } = entry.contentRect;
                setSize({ width, height });
                onResize?.(width, height);
            }
        });

        if (divRef.current) {
            resizeObserver.observe(divRef.current);
        }

        return () => {
            resizeObserver.disconnect();
        };
    }, []);

    return (
        <div className={`p-editor__cols${cols}`} ref={divRef}>
            <div className="p-editor__cols-container" style={{ width: size.width, height: size.height }}>
                {children}
            </div>
            <MaskLoading />
        </div>
    );
};

export default ColsContainer;
